import { Product } from '@/types'

export async function getProducts(): Promise<Product[]> {
    try {
        const response = await fetch(`/api/products`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: 'no-cache'
        });
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error(error);
        return [];
    }
}

export async function getProductsAtServer(): Promise<Product[]> {
    try {
        const response = await fetch(`${process.env.PROD_DOMAIN}${process.env.NEXT_PUBLIC_PRODUCTS}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: 'no-cache'
        });
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error(error);
        return [];
    }
}

export async function getProductById(id: string | number): Promise<Product | undefined> {
    try {
        const response = await fetch(`/api/products/getproduct?id=${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: 'no-cache'
        });
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error(error);
        return undefined;
    }
}

export async function getProductByIdAtServer(id: string | number): Promise<Product | undefined> {
    try {
        const response = await fetch(`${process.env.PROD_DOMAIN}${process.env.NEXT_PUBLIC_API_GET_PRODUCT_BY_ID}?id=${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: 'no-cache'
        });
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error(error);
        return undefined;
    }
}

export async function getProductsByUID(category: string): Promise<Product | undefined> {
    try {
        const response = await fetch(`/api/products/getproductsbyuid?uid=${category}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: 'no-cache'
        });
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error(error);
        return undefined;
    }
}

export async function getProductsByUIDAtServer(category: string): Promise<Product | undefined> {
    try {
        const response = await fetch(`${process.env.PROD_DOMAIN}${process.env.NEXT_PUBLIC_API_GET_PRODUCTS_BY_UID}?uid=${category}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: 'no-cache'
        });
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error(error);
        return undefined;
    }
}

export async function getProductsByIDArray(ids: number[]) {
    const idSet = Array.from(new Set(ids));
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_APIURI}${process.env.NEXT_PUBLIC_PRODUCT_BY_IDS}`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: idSet,
            }),
        }
    );
    const products = await response.json();
    return products;
}